import { useEffect, useState } from "preact/hooks"
import { assignAchievement } from "src/components/Leaderboard"

export const useTimer = (timer = 1000) => {
    const [tm, setTm] = useState(null)

    useEffect(() => {
        const clock = setInterval(() => {
            setTm(new Date().getTime())
        }, timer)

        return () => {
            clearInterval(clock)
        }
    }, [])

    return tm
}

export default ({
    achievementId, userId, eventId, minimalTime = 15, autoReset = false
}) => {
    const timer = useTimer(2000)
    const [counter, setCounter] = useState(Number(window.localStorage.getItem(achievementId)) || 0)
    const [send, setSent] = useState(false)

    useEffect(() => {
        if (counter === "DONE" || send || autoReset) return;
        window.localStorage.setItem(achievementId, counter + 2)
        setCounter(it => it + 2)

        if(counter >= minimalTime * 60 && (!send || autoReset)) {
            assignAchievement({
                entrypoint: "https://leaderboardb.swoogo-retrofit.tkevents.io",
                achievementId,
                eventId,
                userId
            }).finally(() => {
                setSent(true)
                setCounter(0)
                window.localStorage.setItem(achievementId, "DONE")
            })
        }
    }, [timer])

    useEffect(() => {
        setCounter(Number(window.localStorage.getItem(achievementId)) || 0)
        setSent(false)
    }, [achievementId])

    return <></>
}